import { ROUTE_PATH as SignInRoutePath } from './signIn/route-path';
import { ROUTE_PATH as SignUpRoutePath } from './signUp/route-path';
import { ROUTE_PATH as ForgotPasswordRoutePath } from './forgotPassword/route-path';

export const ROUTE_PATH = [
  SignInRoutePath,
  SignUpRoutePath,
  ForgotPasswordRoutePath
];
